// extracted by mini-css-extract-plugin
module.exports = {"app":"s34-","main":"s3ZV"};